import { REQ } from "constants/api/requests"
import { IResponse } from "constants/interfaces"

import useApi from "util/api"

export type BonusCatalogMode = "v2" | "legacy"

/**
 * The tenant's migration mode as the backend sees it (`GET /admin/tenant-mode`). The backend
 * owns `MICROSERVICE_TENANTS` and the bonus / $TOKEN feature flags; the admin used to mirror the
 * first in a build-time env and the two drifted on every cutover. Three predicates, three fields —
 * money, bonus catalog and $TOKEN are gated separately on the backend.
 */
export interface TenantMode {
  tenant: string
  mode: "monolith" | "dual-write" | "microservice" | "gateway"
  /** `fs` — financial-service owns the wallet (native amounts, FS-authoritative balances). */
  money_authority: "fs" | "monolith"
  /** `v2` — bonus-service owns the catalog (Bonus V2 pages), `legacy` — monolith tables. */
  bonus_catalog: BonusCatalogMode
  token_enabled: boolean
}

export const tenantModeService = {
  // Lets the error propagate: the caller decides what an unresolved mode means for the UI.
  async getTenantMode(): Promise<TenantMode | undefined> {
    const { data } = await useApi.get<IResponse<TenantMode>>(REQ.ADMIN_DASHBOARD.TENANT_MODE)
    if (data?.success) return data.response
  }
}
